<script setup>
import { ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { useEmitter } from 'dashboard/composables/emitter';
import { getUnixTime } from 'date-fns';
import { CMD_SET_REMINDER } from 'dashboard/helper/commandbar/events';
import ConversationReminderModal from 'dashboard/components/widgets/conversation/ConversationReminderModal.vue';

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();
const showCustomReminderModal = ref(false);

const setReminder = async remindAt => {
  const conversationId = getters.getContextMenuChatId.value;
  await store.dispatch('setReminder', { conversationId, remindAt });
  store.dispatch('setContextMenuChatId', null);
  useAlert(
    remindAt
      ? t('CHAT_LIST.REMINDER_SET_SUCCESSFUL')
      : t('CHAT_LIST.REMINDER_CANCELLED')
  );
};

const onCmdSetReminder = remindType => {
  if (remindType === 'custom') {
    showCustomReminderModal.value = true;
  } else {
    setReminder(remindType);
  }
};

const chooseReminderTime = customTime => {
  showCustomReminderModal.value = false;
  if (customTime) {
    setReminder(getUnixTime(customTime));
  }
};

const hideCustomReminderModal = () => {
  store.dispatch('setContextMenuChatId', null);
  showCustomReminderModal.value = false;
};

useEmitter(CMD_SET_REMINDER, onCmdSetReminder);
</script>

<template>
  <woot-modal
    v-model:show="showCustomReminderModal"
    :on-close="hideCustomReminderModal"
  >
    <ConversationReminderModal
      @close="hideCustomReminderModal"
      @choose-time="chooseReminderTime"
    />
  </woot-modal>
</template>
